export enum LOCAL_STORAGE_KEYS {
  clearme_id = 'clearme_id'
}
